export default "__VITE_ASSET__Di1c3SNN__"